<template>
  <div class="snapshot-share-page">
    <Loading text="加载中..." :loading="loading"></Loading>

    <div class="share-card" v-if="metaLoaded && needPassword && !hasDetail">
      <h2>{{ shareMeta.title || '报表快照分享' }}</h2>
      <p v-if="shareMeta.remark">{{ shareMeta.remark }}</p>
      <p>该链接需要访问密码</p>
      <input class="share-input" type="password" v-model="password" placeholder="请输入访问密码" />
      <div class="btn-row">
        <Button color="primary" :loading="submitLoading" @click="loadDetail">查看快照</Button>
      </div>
    </div>

    <div class="share-content" v-if="hasDetail">
      <div class="share-header">
        <h2>{{ snapshot.title || '报表快照' }}</h2>
        <p v-if="snapshot.remark" class="snapshot-remark">{{ snapshot.remark }}</p>
        <div class="share-meta">
          <span>快照编号：{{ snapshot.snapshotNo }}</span>
          <span>会计期间：{{ formatDate(snapshot.accountDate) }}</span>
          <span>生成时间：{{ formatDateTime(snapshot.createTime) }}</span>
        </div>
      </div>

      <Tabs :datas="tabDatas" v-model="activeReportKey" class="h-tabs-card" />

      <Table :datas="currentItems" border class="small-td margin-top">
        <TableItem title="项目">
          <div slot-scope="{data}" :class="{'font-bold': data.isBolder}" :style="{paddingLeft:((data.level-1)*15)+'px'}">{{data.title}}</div>
        </TableItem>
        <TableItem title="行次" :width="70">
          <template slot-scope="{data}">
            {{data.isClassified ? '' : (data.lineNum > -1 ? data.lineNum : '')}}
          </template>
        </TableItem>
        <TableItem title="本年" align="right">
          <template slot-scope="{data}">{{ data.currentYearAmount | numFormat }}</template>
        </TableItem>
        <TableItem title="本期" align="right">
          <template slot-scope="{data}">{{ data.currentPeriodAmount | numFormat }}</template>
        </TableItem>
        <TableItem v-if="showLastYear" title="上年同期" align="right">
          <template slot-scope="{data}">{{ data.lastYearAmount | numFormat }}</template>
        </TableItem>
      </Table>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ReportSnapshotShareView',
  props: {
    token: String
  },
  data() {
    return {
      loading: false,
      submitLoading: false,
      metaLoaded: false,
      needPassword: false,
      password: '',
      shareMeta: {},
      snapshot: {},
      reports: [],
      activeReportKey: ''
    }
  },
  computed: {
    hasDetail() {
      return this.reports.length > 0;
    },
    tabDatas() {
      return this.reports.map(r => ({ key: r.reportKey, title: r.reportName }));
    },
    currentReport() {
      return this.reports.find(r => r.reportKey === this.activeReportKey) || null;
    },
    currentItems() {
      return this.currentReport ? this.currentReport.items : [];
    },
    showLastYear() {
      return this.currentReport && this.currentReport.reportType === 3;
    }
  },
  methods: {
    loadMeta() {
      this.loading = true;
      this.$api.report.snapshot.shareMeta(this.token).then(({ data }) => {
        this.shareMeta = data || {};
        this.metaLoaded = true;
        this.needPassword = !!data.requiresPassword;
        if (!this.needPassword) {
          this.loadDetail();
        }
      }).catch(() => {
        this.$Message.error('分享链接无效或已过期');
      }).finally(() => {
        this.loading = false;
      });
    },
    loadDetail() {
      this.submitLoading = true;
      this.loading = true;
      this.$api.report.snapshot.shareView(this.token, { password: this.password }).then(({ data }) => {
        this.snapshot = data.snapshot || {};
        this.reports = data.reports || [];
        if (this.reports.length > 0) {
          this.activeReportKey = this.reports[0].reportKey;
        }
      }).catch((error) => {
        if (error && error.msg) {
          this.$Message.error(error.msg);
        }
      }).finally(() => {
        this.submitLoading = false;
        this.loading = false;
      });
    },
    formatDate(date) {
      if (!date) return '-';
      const d = new Date(date);
      if (isNaN(d.getTime())) return date;
      return `${d.getFullYear()}-${this.pad(d.getMonth() + 1)}-${this.pad(d.getDate())}`;
    },
    formatDateTime(date) {
      if (!date) return '-';
      const d = new Date(date);
      if (isNaN(d.getTime())) return date;
      return `${d.getFullYear()}-${this.pad(d.getMonth() + 1)}-${this.pad(d.getDate())} ${this.pad(d.getHours())}:${this.pad(d.getMinutes())}`;
    },
    pad(n) {
      return n < 10 ? `0${n}` : `${n}`;
    }
  },
  mounted() {
    this.loadMeta();
  }
}
</script>

<style scoped>
.snapshot-share-page {
  min-height: 100vh;
  background: #f5f6f8;
  padding: 20px;
}
.share-card {
  max-width: 480px;
  margin: 60px auto;
  background: #fff;
  padding: 20px;
  border-radius: 8px;
}
.share-input {
  width: 100%;
  border: 1px solid #dcdee2;
  border-radius: 4px;
  padding: 8px;
  margin-top: 8px;
}
.btn-row {
  margin-top: 12px;
}
.share-content {
  background: #fff;
  border-radius: 8px;
  padding: 16px;
}
.share-meta {
  display: flex;
  gap: 16px;
  color: #666;
}
.snapshot-remark {
  color: #666;
  margin-bottom: 6px;
}
.font-bold {
  font-size: 14px;
}
</style>
